import IconBase from "./IconBase";

// Entries: a container holding records, each a marker and its title. Replaces
// the old paintbrush, which said nothing about content.
const ContentIcon = (props) => (
    <IconBase {...props}>
        <rect x="3" y="3" width="18" height="18" rx="3.5" />
        <circle cx="7.75" cy="8.5" r="1.1" fill="currentColor" stroke="none" />
        <circle cx="7.75" cy="12" r="1.1" fill="currentColor" stroke="none" />
        <circle cx="7.75" cy="15.5" r="1.1" fill="currentColor" stroke="none" />
        <path d="M11.25 8.5H17.25" />
        <path d="M11.25 12H17.25" />
        <path d="M11.25 15.5H14.75" />
    </IconBase>
);

export default ContentIcon;
